import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'templateFunc',
	pure: true,
	standalone: true
})
export class TemplateFunctionPipe implements PipeTransform {
	// eslint-disable-next-line @typescript-eslint/ban-types
	transform(func: Function, args: unknown[] = [], bind: unknown = null): unknown {
		return func.call(bind, ...args);
	}
}
